import { configureStore } from '@reduxjs/toolkit';
import jobConfigurationReducer from './reducers/jobConfiguration/jobConfiguration';
import genericTableReducer from './reducers/genericTable/genericTable';
import userDataReducer from './reducers/userData/userData';
import userPermissionsReducer from './reducers/userPermissions/userPermissions';
import dashboardReducer from './reducers/dashboard/dashboard';
import netbatchJobsReducer from './reducers/netbatchJobs/netbatchJobs';

const store = configureStore({
  reducer: {
    jobConfiguration: jobConfigurationReducer,
    genericTable: genericTableReducer,
    userData: userDataReducer,
    userPermissions: userPermissionsReducer,
    dashboard: dashboardReducer,
    netbatchJobs: netbatchJobsReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.REACT_APP_LOCAL_RUN === 'true',
});

export default store;
